import { DeliveryVan, GiftBox, Gphc } from '@modules/common/icons';
import type { JSX } from 'react';

export type TopbarItem = {
  label: string;
  icon: JSX.Element;
};

export const TOPBAR_ITEMS: TopbarItem[] = [
  {
    label: 'GPhC Registered Pharmacy',
    icon: <Gphc size="20" aria-hidden="true" />,
  },
  {
    label: 'Discreet Packaging',
    icon: <GiftBox size="20" aria-hidden="true" />,
  },
  {
    label: 'Next Day Delivery',
    icon: <DeliveryVan size="20" aria-hidden="true" />,
  },
];
